import { renderSlot as _renderSlot, mergeProps as _mergeProps, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("span", _mergeProps({
        class: ["g-color-badge", _ctx.variantClass]
    }, _ctx.$attrs, { style: _ctx.colorStyle }), [
        _renderSlot(_ctx.$slots, "default")
    ], 16));
}
